/**
 * SiteGlue site-wide page hierarchy — one story across every marketing page.
 *
 * Home — Connect Every Conversation to the Right Person.
 * Platform — Always a Human-in-the-Loop™
 * Features — How Humans and AI Work Together
 * AI Employees — Explore live agents in action (URL preserved)
 * Pricing — Set Up Your Agent
 * About — Why I Believe AI Should Work Alongside People
 */

export const SITEGLUE_PAGE_STORY = {
  home: {
    navLabel: "Home",
    /** Eyebrow / brand line above the homepage hero */
    line: "Agents Connecting People.",
    href: "/",
  },
  platform: {
    navLabel: "Platform",
    /** Short nav / mega-menu label */
    pageTitle: "Platform",
    /** Document / SEO title */
    metaTitle: "Human-in-the-Loop™ Platform",
    /** Hero eyebrow — the page’s job in the story */
    line: "Always a Human-in-the-Loop™",
    href: "/platform",
  },
  features: {
    navLabel: "Features",
    pageTitle: "Features",
    metaTitle: "Features",
    line: "How Humans and AI Work Together",
    href: "/features",
  },
  pricing: {
    navLabel: "Pricing",
    pageTitle: "Pricing",
    metaTitle: "Pricing",
    line: "Set Up Your Agent",
    href: "/pricing",
  },
  about: {
    navLabel: "About",
    pageTitle: "About",
    metaTitle: "About",
    line: "Why I Believe AI Should Work Alongside People",
    href: "/about",
  },
  industries: {
    navLabel: "Industries",
    pageTitle: "Industries",
    metaTitle: "Industries",
    line: "SiteGlue Agent solutions for every industry SiteGlue supports.",
    href: "/healthcare",
  },
  myTeam: {
    navLabel: "My Team",
    pageTitle: "My Team",
    metaTitle: "My Team",
    line: "Meet the Agents who help SiteGlue serve customers—with humans always in control.",
    href: "/about/my-team",
  },
  solutions: {
    navLabel: "Solutions",
    pageTitle: "Solutions",
    metaTitle: "Solutions",
    line: "Achieve measurable business outcomes with SiteGlue Agent.",
    href: "/solutions/increase-sales",
  },
  aiEmployees: {
    navLabel: "Roles",
    pageTitle: "SiteGlue Agent",
    metaTitle: "SiteGlue Agent",
    line: "Explore live agents in action.",
    href: "/agents",
  },
} as const;

export type SiteGluePageKey = keyof typeof SITEGLUE_PAGE_STORY;
